import { Button } from '@southfields-digital/mxmz-react-ui';
import { useDispatch, useSelector } from 'react-redux';

import type { StateType } from 'src/redux/reducers';
import {
  REQUEST_UPDATE_LIVE_GRAPHIC,
  REQUEST_UPDATE_PREVIEW_GRAPHIC,
} from 'src/redux/reducers/control';

interface IUpdateGraphicButtonProps {
  selectedGraphic: PlaylistGraphic;
  target: 'live' | 'preview';
  isPropertiesDirty: boolean;
  onUpdate: () => void;
}

export default function UpdateGraphicButton({
  selectedGraphic,
  target,
  isPropertiesDirty,
  onUpdate,
}: IUpdateGraphicButtonProps) {
  const dispatch = useDispatch();
  const isUpdating = useSelector((state: StateType) => state.playlistGraphic.loading);

  const handleUpdate = () => {
    dispatch({
      type: target === 'live' ? REQUEST_UPDATE_LIVE_GRAPHIC : REQUEST_UPDATE_PREVIEW_GRAPHIC,
      payload: { playlistGraphicId: selectedGraphic.id, payload: 'data:update' },
    });
    onUpdate();
  };

  return (
    <Button
      as="button"
      buttonSize="small"
      variant="muted"
      onClick={handleUpdate}
      disabled={isUpdating || !isPropertiesDirty || !selectedGraphic.status[target]}
      className="!outline-none !ring-0"
      iconProps={{
        icon: 'check',
        size: 16,
        weight: 'bold',
      }}
    >
      {target === 'live' ? 'Update PGM' : 'Update PVW'}
    </Button>
  );
}
